import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';

export const RELATIVE_URL = 'user-permissions';

export const COLUMNS_TO_SHOW_WEB = [
  'name',
  'allow',
];
export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;
export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'name',
    display: 'PERMISSÕES DO GRUPO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
];
